export default "../css/c092257afdb650be08ebbbb3b8848e10.ttf";